module.exports = __webpack_public_path__ + "img/935-58231c.png";